var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/_core.js
// module id = 21
// module chunks = 0